import { routes } from '@router';
import { UserForm } from '../../components';
import { useUserDynamicPage } from '../../hooks';

const ViewPage = () => {
  const { data, isLoading } = useUserDynamicPage(routes.dashboard.sub.user.path);

  return <UserForm data={data} isLoading={isLoading} displayOnly />;
};

export default ViewPage;
